module.exports = __webpack_public_path__ + "img/pending-icon.87c5e96a.png";